import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/iris/vigiladoiris.png'
import _imports_1 from '@/assets/iris/iris.png'
import _imports_2 from '@/assets/iris/listo.svg'


const _withScopeId = n => (_pushScopeId("data-v-c2b2510e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lg:container mx-auto border my-2 rounded w-full bg-white shadow-lg" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute legend hidden lg:flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-5 legend-img",
    src: _imports_0,
    alt: "vigiladoiris"
  })
], -1))
const _hoisted_3 = { class: "lg:px-12 lg:py-8" }
const _hoisted_4 = { class: "mt-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex lg:justify-between justify-around pb-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-32 lg:w-48 h-full",
    src: _imports_1,
    alt: "logo_iris"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-32 lg:w-72 lg:flex",
    src: _imports_2,
    alt: "logo_listo"
  })
], -1))
const _hoisted_6 = { class: "flex flex-col lg:flex-row justify-between mx-2" }
const _hoisted_7 = { class: "pb-3" }
const _hoisted_8 = { class: "text-sm lg:text-lg" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Señor(a): ", -1))
const _hoisted_10 = { class: "text-sm lg:text-lg" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Compra en: ", -1))
const _hoisted_12 = { class: "pb-3" }
const _hoisted_13 = { class: "text-sm lg:text-lg" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Referencia de pago: ", -1))
const _hoisted_15 = { class: "text-sm lg:text-lg" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-grisTitle font-bold" }, "Número de crédito: ", -1))
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"rounded-md px-4 my-2\" data-v-c2b2510e><p class=\"text-xs lg:text-md text-justify\" data-v-c2b2510e> Estimado cliente, si su obligación financiera presenta días de mora, se podrán generar <span class=\"font-bold\" data-v-c2b2510e>cargos por cobranza entre el 4% al 20% de acuerdo con la altura de mora mas IVA</span> calculados sobre los conceptos no pagados. En caso de requerir información adicional para realizar su pago, por favor comunicarse con nuestra Línea de Servicio al Cliente <span class=\"font-bold\" data-v-c2b2510e>601 744 2333</span> en Bogotá o <span class=\"font-bold\" data-v-c2b2510e>01 8000 111 280 </span> a nivel nacional. </p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaymentDetail = _resolveComponent("PaymentDetail")!
  const _component_Channels = _resolveComponent("Channels")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.data.nombre_cliente), 1)
            ]),
            _createElementVNode("p", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.data.nombre_comercio), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(" " + _toDisplayString(_ctx.data.referencia_pago_2), 1)
            ]),
            _createElementVNode("p", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(_toDisplayString(_ctx.data.numero_obligacion), 1)
            ])
          ])
        ])
      ]),
      _createVNode(_component_PaymentDetail, { data: _ctx.data }, null, 8, ["data"]),
      _createVNode(_component_Channels),
      _hoisted_17
    ]),
    _createVNode(_component_Footer, { "is-iris-anchor": true })
  ]))
}